import React from "react";
import Page48hMain from "./PageMain_V2/PageMain";
import Page48hTestInfo from "./PageMain_V2/PageTestInfo";
import Page48hChart from "./PageMain_V2/PageChart";
import Page48hRadonTable from "./PageMain_V2/PageRadonTable";
import PageAdditional from "./Page48h/PageAdditional";
import PageRecommendations from "./Page48h/PageRecommendations";
import PageUncertainty from "./Page48h/PageUncertainty";

export const PAGE_MAIN = 0;
export const PAGE_TEST_INFO = 1;
export const PAGE_CHART = 2;
export const PAGE_RADON_TABLE = 3;
export const PAGE_ADDITIONAL = 4;
export const PAGE_RECOMMENDATIONS = 5;
export const PAGE_UNCERTAINTY = 6;

const pageStyle = {
  padding: "0px 0px 0px 0px",
  width: "612px",
  height: "100%",
  border: "1px solid #E6E8F0",
  backgroundColor: "white",
};

const ReportPreview = ({
  page,
  reportDetails,
  reportChartRadonValue,
  pageAdditional,
  pageRecommendations,
  pageUncertainty,
}) => {
  const is48h = reportDetails?.req_type === "RPT_48H" || reportDetails?.measurement_duration === "48 Hours";

  return (
    <div>
      {/* Base 3 Pages: Always Visible */}
      <div hidden={page !== PAGE_MAIN} style={pageStyle}>
        <Page48hMain
          reportDetails={reportDetails}
          reportChartRadonValue={reportChartRadonValue}
        />
      </div>

      <div hidden={page !== PAGE_TEST_INFO} style={pageStyle}>
        <Page48hTestInfo reportDetails={reportDetails} />
      </div>

      <div hidden={page !== PAGE_CHART} style={pageStyle}>
        <Page48hChart
          reportDetails={reportDetails}
          reportChartRadonValue={reportChartRadonValue}
        />
      </div>

      {/* 48hr Pages */}
      {is48h && (
        <>
          <div hidden={page !== PAGE_RADON_TABLE} style={pageStyle}>
            <Page48hRadonTable
              reportDetails={reportDetails}
              reportChartRadonValue={reportChartRadonValue}
            />
          </div>

          <div hidden={page !== PAGE_ADDITIONAL} style={pageStyle}>
            <PageAdditional reportDetails={reportDetails} />
          </div>

          <div hidden={page !== PAGE_RECOMMENDATIONS} style={pageStyle}>
            <PageRecommendations reportDetails={reportDetails} />
          </div>

          <div hidden={page !== PAGE_UNCERTAINTY} style={pageStyle}>
            <PageUncertainty reportDetails={reportDetails} />
          </div>
        </>
      )}
    </div>
  );
};

export default ReportPreview;
